import { types } from "../../types/types";

const initialState = {
  curtomersBillingr: []
}

export const CustomersBillingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.customerBillingLoading:
      return{
        ...state,
        curtomersBillingr: [ ...action.payload ]
      }
      
    default:
      return state;
  }
}
